module.exports = __webpack_public_path__ + "static/media/border03.4a4c861d.png";